var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8884 2.45865H12.9115C13.1234 2.43406 13.3374 2.43406 13.5492 2.45865C15.0686 2.63495 16.1574 4.01095 15.9813 5.53197V7.27273H0.0186775V5.53203C-0.00588039 5.31987 -0.00588039 5.10567 0.0186775 4.89357C0.194774 3.37248 1.56917 2.28235 3.08848 2.45865H4.11173V1.43421C4.11265 0.642528 4.75344 0.000917897 5.54427 0H10.4559C11.2466 0.000917897 11.8875 0.642462 11.8884 1.43421V2.45865ZM0.0186775 8.48485V12.908C-0.157419 14.4291 0.931446 15.805 2.45076 15.9813C2.66262 16.0059 2.87656 16.0059 3.08842 15.9813H12.9116C14.4309 16.1576 15.8052 15.0675 15.9813 13.5464C16.0059 13.3343 16.0059 13.1201 15.9813 12.908V8.48485H0.0186775ZM5.54421 1.22933C5.43118 1.22933 5.33956 1.32105 5.33956 1.43421V2.45865H10.6604V1.43421C10.6604 1.32105 10.5688 1.22933 10.4558 1.22933H5.54421ZM8.01637 11.2688C8.4685 11.2688 8.83497 10.9019 8.83497 10.4493C8.8349 9.99668 8.46843 9.62972 8.01631 9.62972H8.00812C7.55927 9.63424 7.19777 9.99655 7.19777 10.4492C7.19777 10.9019 7.56424 11.2688 8.01637 11.2688Z",
    fill: "#474554"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.7a02874d4583cacde85eebca3fba285a.svg";
export { ForwardRef as ReactComponent };